<script setup lang="ts">
interface SeparatorLineProperties {
  widthClass?: string;
  heightClass?: string;
  colorClass?: string;
}

withDefaults(defineProps<SeparatorLineProperties>(), {
  widthClass: 'w-full',
  heightClass: 'h-px',
  colorClass: 'bg-gray-100',
});
</script>
<template>
  <span :class="[widthClass, heightClass, colorClass, 'block min-h-px']" />
</template>
